import React from 'react'
import Footer from './presentational/Footer'
import Header from './presentational/Header'

const LOCATIONS = [
  {
    name: 'Aurora',
    address: '2 Orchard Heights Blvd Unit 31, Aurora, ON L4G 6T5',
    phone: '(905) 409-6284',
    phoneHref: 'tel:+19054096284',
    email: 'equationhub.info@gmail.com',
    mapsLink:
      'https://www.google.com/maps/place/Equation+Hub/@44.009253,-79.4739839,17z/data=!4m6!3m5!1s0x882ad18f9dd87431:0x9d62cdfa8c00f5a0!8m2!3d44.009253!4d-79.471409!16s%2Fg%2F11wc0dn116',
    embed:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2869.587482449728!2d-79.4739839!3d44.009253!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882ad18f9dd87431%3A0x9d62cdfa8c00f5a0!2sEquation%20Hub!5e0!3m2!1sen!2s!4v1728932962918!5m2!1sen!2s',
  },
  {
    name: 'Richmond Hill',
    address: '642 Major Mackenzie Dr E, Richmond Hill, ON L4C 1J9',
    phone: '(647) 201-3474',
    phoneHref: 'tel:+16472013474',
    email: 'equationhub.info@gmail.com',
    mapsLink:
      'https://www.google.com/maps/place/Equation+Hub/data=!4m2!3m1!1s0x0:0x2ed03ab3b10cf3bc?sa=X&ved=1t:2428&hl=en-us&ictx=111',
    embed:
      'https://maps.google.com/maps?q=642%20Major%20Mackenzie%20Dr%20E%2C%20Richmond%20Hill%2C%20ON%20L4C%201J9&t=&z=15&ie=UTF8&iwloc=&output=embed',
  },
]

function Locations() {
  return (
    <div className="locations-page">
      <Header />
      <div className="container py-5">
        <div className="text-center mb-5">
          <h1 className="font-bold font-60 text-primary">Our Locations</h1>
          <p className="font-18 mt-3">
            Visit Equation Hub at either of our convenient locations in Aurora and Richmond Hill.
          </p>
        </div>
        <div className="row justify-content-center g-4">
          {LOCATIONS.map((loc) => (
            <div key={loc.name} className="col-md-6">
              <div className="location-card h-100">
                <div className="location-map">
                  <iframe
                    title={`${loc.name} location map`}
                    src={loc.embed}
                    width="100%"
                    height="280"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
                <div className="location-body p-4">
                  <h2 className="font-bold font-50 mb-3">{loc.name}</h2>
                  <div className="d-flex aic mt-3">
                    <div className="icon me-2 text-center">
                      <i className="fas fa-map-marker-alt text-primary" />
                    </div>
                    <a
                      className="text-decoration-none text-dark"
                      href={loc.mapsLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {loc.address}
                    </a>
                  </div>
                  <div className="d-flex aic mt-3">
                    <div className="icon me-2 text-center">
                      <i className="fas fa-phone text-primary" />
                    </div>
                    <a href={loc.phoneHref} className="text-decoration-none text-dark">
                      {loc.phone}
                    </a>
                  </div>
                  <div className="d-flex aic mt-3">
                    <div className="icon me-2 text-center">
                      <i className="fas fa-envelope text-primary" />
                    </div>
                    <a
                      href={`mailto:${loc.email}`}
                      className="text-decoration-none text-dark"
                    >
                      {loc.email}
                    </a>
                  </div>
                  <a
                    href={loc.mapsLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn contantBtn px-4 py-2 mt-4"
                  >
                    Get Directions
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Locations
